/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Charts_FailedInputs */

const en_us2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the charts.`)
};

const pt_br2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os gráficos.`)
};

const es_419_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las gráficas.`)
};

const pt_pt2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os gráficos.`)
};

const fr_fr2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les graphiques.`)
};

const de_de2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Diagramme konnten nicht geladen werden.`)
};

const it_it2_exercise_sheet_charts_failed = /** @type {(inputs: Exercise_Sheet_Charts_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i grafici.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the charts." |
*
* @param {Exercise_Sheet_Charts_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_charts_failed = /** @type {((inputs?: Exercise_Sheet_Charts_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Charts_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_charts_failed(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_charts_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_charts_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_charts_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_charts_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_charts_failed(inputs)
	return en_us2_exercise_sheet_charts_failed(inputs)
});
export { exercise_sheet_charts_failed as "exercise-sheet.charts_failed" }